import Typography from "../Typography";
import { CheckCircle } from "@phosphor-icons/react";
import clsx from "clsx";

type ArrowStepProps = {
    stepNumber: number;
    stepLabel: string;
    currentStep: number;
};

const ArrowStep = ({ stepNumber, stepLabel, currentStep }: ArrowStepProps) => {
    return (
        <div className="flex -ml-3">
            <div
                className={clsx(
                    "w-0 border-y-[16px] border-l-[16px] border-solid border-l-transparent border-deep-ocean-20",
                    currentStep < stepNumber && "border-gray-200"
                )}
            ></div>
            <div
                className={clsx(
                    "flex items-center w-full bg-deep-ocean-20",
                    currentStep < stepNumber && "bg-gray-200"
                )}
            >
                <div className="flex items-center ml-2 mr-1 w-full justify-between">
                    <Typography
                        variant="label-medium"
                        component="label"
                        className={clsx(
                            "pr-1 text-black",
                            currentStep >= stepNumber && "text-white"
                        )}
                    >
                        {stepLabel}
                    </Typography>
                    {currentStep > stepNumber && (
                        <CheckCircle
                            className="flex-shrink-0"
                            weight="fill"
                            color="#B5D88A"
                            size="20"
                        ></CheckCircle>
                    )}
                </div>
            </div>
            <div
                className={clsx(
                    "w-0 border-y-[16px] border-l-[16px] border-solid border-transparent border-l-deep-ocean-20",
                    currentStep < stepNumber &&
                        "border-gray-200 border-l-gray-200"
                )}
            ></div>
        </div>
    );
};

export default ArrowStep;
